module.exports = __webpack_public_path__ + "assets/img/e4bf3674f7286108d0b1363d11451698.png";